import styled from "styled-components";

export const Container = styled.div`
  @media (max-width: 766px) {
    padding: 0 16px;
  }
`;